export const getDictName = (val, arr, type) => {
  val = val + "";
  let _name;
  for (let i = 0, len = arr.length; i < len; i++) {
    if (val === arr[i].value) {
      _name = arr[i].label;
      break;
    }
  }
  return _name;
};